import { useEffect, useState } from "react";
import { marked } from "marked";
import { DnaLogo } from "@/components/brand/DnaLogo";

export default function PortalGuidePage() {
  const [html, setHtml] = useState<string>("");
  const [error, setError] = useState(false);

  useEffect(() => {
    document.title = "Member Portal — User Guide | Don Norman Associates";
    fetch("/portal-user-guide.md")
      .then((r) => {
        if (!r.ok) throw new Error("not found");
        return r.text();
      })
      .then((md) => setHtml(marked(md) as string))
      .catch(() => setError(true));
  }, []);

  return (
    <div style={{ minHeight: "100vh", background: "#F7F4EE", fontFamily: "'DM Sans', system-ui, sans-serif" }}>
      <link
        rel="stylesheet"
        href="https://fonts.googleapis.com/css2?family=Playfair+Display:wght@600;700&family=DM+Sans:wght@300;400;500;600&display=swap"
      />

      <header style={{
        background: "#1B2B4B",
        padding: "14px 40px",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        borderBottom: "1px solid rgba(255,255,255,0.06)",
      }}>
        <div style={{ background: "white", borderRadius: 8, padding: "6px 12px", display: "flex", alignItems: "center" }}>
          <DnaLogo height={28} />
        </div>
        <span style={{ color: "rgba(255,255,255,0.55)", fontSize: 12, fontWeight: 500, letterSpacing: "0.12em", textTransform: "uppercase" }}>
          MEMBER PORTAL
        </span>
        <button
          onClick={() => window.close()}
          style={{ background: "none", border: "1px solid rgba(255,255,255,0.2)", color: "rgba(255,255,255,0.6)", fontSize: 12, padding: "4px 10px", borderRadius: 6, cursor: "pointer" }}
        >
          Close
        </button>
      </header>

      <div style={{ maxWidth: 780, margin: "0 auto", padding: "48px 24px 80px" }}>
        <div style={{ background: "white", borderRadius: 16, boxShadow: "0 20px 60px rgba(27,43,75,0.12)", padding: "clamp(28px,5vw,56px) clamp(24px,6vw,64px)" }}>
          {error ? (
            <p style={{ color: "#dc2626", textAlign: "center", padding: 40 }}>
              Unable to load the user guide. Please contact support at <strong>703-821-0000</strong>.
            </p>
          ) : html ? (
            <div
              className="guide-content"
              dangerouslySetInnerHTML={{ __html: html }}
            />
          ) : (
            <div style={{ textAlign: "center", padding: 60, color: "#9ca3af" }}>Loading…</div>
          )}
        </div>
      </div>

      <style>{`
        .guide-content { color: #1a1a1a; line-height: 1.7; font-size: 15px; }
        .guide-content h1 { font-family: 'Playfair Display', Georgia, serif; font-size: 2rem; font-weight: 700; color: #1B2B4B; margin: 0 0 8px; line-height: 1.2; }
        .guide-content h2 { font-family: 'Playfair Display', Georgia, serif; font-size: 1.35rem; font-weight: 700; color: #1B2B4B; margin: 40px 0 12px; padding-bottom: 8px; border-bottom: 2px solid #e2ddd6; }
        .guide-content h3 { font-size: 1rem; font-weight: 600; color: #1B2B4B; margin: 24px 0 8px; }
        .guide-content p { margin: 0 0 14px; }
        .guide-content ul, .guide-content ol { margin: 0 0 14px; padding-left: 24px; }
        .guide-content li { margin-bottom: 6px; }
        .guide-content strong { font-weight: 600; color: #111; }
        .guide-content a { color: #C9962A; }
        .guide-content hr { border: none; border-top: 1px solid #e2ddd6; margin: 32px 0; }
        .guide-content blockquote { border-left: 3px solid #C9962A; margin: 16px 0; padding: 10px 16px; background: #fdf8f0; border-radius: 0 8px 8px 0; color: #555; font-size: 14px; }
        .guide-content blockquote p { margin: 0; }
        .guide-content code { background: #f3f4f6; padding: 2px 6px; border-radius: 4px; font-size: 13px; font-family: monospace; }
      `}</style>
    </div>
  );
}
